module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-multi/select2-multi.component.scss
// module id = ./src/app/components/tools/select2/select2-multi/select2-multi.component.scss
// module chunks = main